<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12" v-show="isLoading">
                <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status" >
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>

            </div>

        </div>

        <div class="row ">

            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <form  class="needs-validation" @submit.prevent="formSubmit">
                            <div class="form-row">
                                <div class="form-group col-md-8">
                                    <label>Descripcion</label>
                                    <input v-model="model.descripcion"
                                           placeholder="Nombre de Oficina"
                                           type="text"
                                           class="form-control"
                                           :class="{ 'is-invalid': submitted && $v.model.descripcion.$error }"
                                    />
                                    <div v-if="submitted && $v.model.descripcion.$error" class="invalid-feedback">
                                        <span v-if="!$v.model.descripcion.required">Este valor es requerido.</span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group label="Siglas" label-for="formrow-firstname-input">
                                        <b-form-input v-model="model.siglas" placeholder="SIGLAS" type="text" />
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label>Escuela profesional</label>
                                    <v-select
                                            :options="carreras_profesionales"
                                            label="carrera"
                                            :reduce="carrera=>carrera.codigo"
                                            v-model="model.codigos_carrera"
                                            multiple
                                   />
                                </div>

                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label>Usuarios</label>
                                    <v-select
                                            :options="usuarios"
                                            label="name"
                                            :reduce="usuario=>usuario.id"
                                            v-model="model.oficina_usuarios"
                                            multiple
                                    />
                                </div>

                            </div>
                            <div>
                                <b-button type="submit" class="mt-4">Guardar</b-button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import constantes from "../../../config/Constantes";
    import {required} from "vuelidate/lib/validators";

    //  import DatePicker from "vue2-datepicker";

    /**
     * Form Layouts component
     */
    export default {
        page: {
            title: "Registro de socios",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: { Layout, PageHeader },
        validations: {
            model: {
                descripcion: {required},
            }
        },

        data() {
            return {
                title: "Registro de ubicaciones",
                items: [
                    {
                        text: "Administracion",
                        href: "/"
                    },
                    {
                        text: "Edicion ubicaciones",
                        active: true
                    }
                ],
                name:'',
                siglas:'',
                model:{
                    name:'',
                    siglas:'',
                    codigos_carrera:[]
                },
                isLoading:false,
                carreras_profesionales:constantes.carreras_profesionales,
                submitted: false,
                usuarios:[],


            };
        },
        methods:
        {
            formSubmit()
            {
                this.submitted = true;
                // stop here if form is invalid
                this.$v.$touch();
                if(this.$v.$error===false){
                    this.guardar();
                }
            },
            guardar(){
                    let title='';
                    let msg='';
                    let icon='';
                    this.isLoading=true;

                    this.axios.post(process.env.VUE_APP_BACKEND+'/api/oficinas',
                    {
                        model:this.model
                    })
                    .then((response)=>
                    {
                        console.log(response.data);
                        if(response.data.success)
                        {
                            title='Guardado!';
                            msg='Registrado en la en la base de datos.';
                            icon='success';
                            this.$router.push('/administracion/oficinas');
                        }
                        else
                        {
                            title='Error!';
                            msg='Error al agregar registro!';
                            icon='error';
                        }
                        this.$swal(title,msg,icon);
                        this.isLoading=false;
                    })
                    .catch(function(error){
                        console.log(error);
                    });
                },
            }
        ,
        mounted() {
            if(!isNaN(this.$route.params.id))
            {
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND + '/api/oficinas/'+this.$route.params.id)
                    .then( (response)=>
                    {

                        this.model=response.data;
                        this.model.codigos_carrera=[];
                        this.model.carreras.forEach((item)=>{
                            this.model.codigos_carrera.push(item.codigo_carrera)
                            });
                        console.log(this.model);
                        //this.$parent.resetReload();
                    })
                .finally(()=>{
                    this.isLoading=false;
                });
            }
            this.axios.get(process.env.VUE_APP_BACKEND + '/api/usuarios')
                .then(response=>{
                    this.usuarios=response.data;
                });

        },
        beforeMount() {

        }
    };
</script>
